import { createMultipleListQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'

export const useIndicatorStatus = createSharedComposable(() => {
    return createMultipleListQuery(
        'indicator-status',
        [
            {
                label: 'Not Met',
                value: 0,
                negativeColor: '#006C7A',
                color: '#A51930'
            },
            {
                label: 'Met',
                value: 1,
                color: '#006C7A',
                negativeColor: '#A51930'
            }
        ],
        {
            get: value =>
                value
                    ?.split(/(?!^-)-(-?[0-9]+)/)
                    .filter(Boolean)
                    .map(Number)
        }
    )
})
